import React from 'react'
import { Link } from 'react-router-dom';

function MembershipBenefits({ title, description = "", benefits = [], buttonName = "", pathname = "", onClick = null }) {


    let benefitPosition = 1;

    const getRadiusClass = () => {
        let radiusClass = 'rounded-tl-md'
        switch (benefitPosition) {
            case 2:
                radiusClass = 'rounded-tr-md'
                break;
            case 3:
                radiusClass = 'rounded-bl-md'
                break;
            case 4:
                radiusClass = 'rounded-br-md'
                break;
            default:
                radiusClass = 'rounded-tl-md'
                break;
        }
        return radiusClass;
    }

    return (
        <section className="w-full bg-gradient-radial py-2 lg:py-2" id="membership-benefits">
            <div className="container mx-auto px-4 lg:px-24">
                <div className='w-full flex flex-col items-center gap-6 mb-4'>
                    <h2
                        className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                        {title}
                    </h2>
                    {
                        !!description && (
                            <p className="text-sm sm:text-base lg:text-xl font-urbanist text-stone-300">
                                {description}
                            </p>
                        )
                    }
                    {
                        !!buttonName && (
                            <Link to={pathname} onClick={onClick} className="group flex items-center bg-white border border-gray-300 text-gray-900 font-medium p-[0.15rem] rounded-full rounded-tr-lg shadow-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <span className='px-6 font-urbanist md:text-2xl text-xl group-hover:scale-105'>{buttonName}</span>
                                <span className="flex items-center justify-center w-8 h-8 rounded-full p-1 rounded-tr-lg border-2 transition border-black group-hover:bg-black group-hover:scale-105">
                                    <img className="group-hover:invert group-hover:text-white transition-transform" src="/assets/services/1/arrow-right.png" alt="arrow-right" />
                                </span>
                            </Link>
                        )
                    }
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 p-4">
                    {
                        benefits.map((memberBenefits, index) => {
                            const radiusClass = getRadiusClass();
                            if (benefitPosition === 4) {
                                benefitPosition = 1;
                            } else {
                                benefitPosition += 1;
                            }
                            return (
                                <div
                                    key={index}
                                    className={`w-full bg-gradient-radial p-6 md:p-6 rounded-3xl ${radiusClass} border border-white flex flex-col items-start gap-8`}
                                >
                                    <div className="gap-6 flex flex-row items-start text-left transition-transform hover:scale-105">
                                        <div className='flex items-start gap-6 mb-2 lg:mb-4'>
                                            <img className="w-8 h-8 lg:w-9 lg:h-9 flex-shrink-0" src={memberBenefits.icon} alt={memberBenefits.alt} />
                                        </div>
                                        <div className='flex flex-col items-start gap-3 lg:gap-6 mb-4'>
                                            <h3 className="text-white text-[1.2rem] font-semibold font-urbanist leading-normal">
                                                {memberBenefits.title}
                                            </h3>
                                            <p className="text-white text-base font-normal font-urbanist font-italic leading-normal">
                                                {memberBenefits.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default MembershipBenefits